module.exports = __webpack_public_path__ + "img/paryoll1.83200d28.jpg";